import CommonTable from './common-table.vue'

CommonTable.install = function (Vue) {
  Vue.component('common-table', CommonTable)
}

export default CommonTable
